var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "PortalWidget",
    {
      attrs: {
        widget: {
          title: _vm.$t("CAMPAIGN_STEP_ROUTING_SELECTED_HEADER")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "headerContent",
          fn: function() {
            return [
              _c("div", { staticClass: "header-extra" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filters.name.value,
                      expression: "filters.name.value"
                    }
                  ],
                  staticClass: "form-control input-md",
                  attrs: { type: "search", placeholder: _vm.$t("SEARCH") },
                  domProps: { value: _vm.filters.name.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filters.name, "value", $event.target.value)
                    }
                  }
                })
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _vm.isTargetPassthrough
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "CAMPAIGN_WARNING_TARGET_GROUPS_PASSTHROUGH",
                expression: "'CAMPAIGN_WARNING_TARGET_GROUPS_PASSTHROUGH'"
              }
            ],
            staticClass: "bs-callout bs-callout-warning description m-t-0"
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid_table_holder" },
        [
          _c(
            "v-table",
            {
              staticClass: "table_beauty table-condensed",
              attrs: {
                data: _vm.displayRoutes,
                "current-page": _vm.currentPage,
                "page-size": 10,
                filters: _vm.filters,
                "hide-sort-icons": true,
                cellpadding: "0",
                cellspacing: "0"
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                },
                totalPagesChanged: function($event) {
                  _vm.totalPages = $event
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ displayData }) {
                    return _c(
                      "tbody",
                      {},
                      [
                        _vm._l(displayData, function(callRoute) {
                          return [
                            !(
                              _vm.isMobileView &&
                              _vm.context.activeActionRouteId == callRoute.id
                            )
                              ? _c(
                                  "tr",
                                  {
                                    key: callRoute.id,
                                    staticClass: "vertical-top"
                                  },
                                  [
                                    _vm.isMobileView
                                      ? _c("td", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-list-function btn-expand-actions",
                                              on: {
                                                click: function($event) {
                                                  return _vm.context.activateRouteActions(
                                                    callRoute.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-ellipsis-v"
                                              })
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.context.isRPC
                                      ? _c(
                                          "td",
                                          [
                                            _c("NumberStepperInput", {
                                              attrs: {
                                                min: "1",
                                                "input-class": "input-xs"
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.context.updateCallRoute(
                                                    callRoute
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  callRoute.priority.priority,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    callRoute.priority,
                                                    "priority",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "callRoute.priority.priority"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.context.isRPC
                                      ? _c(
                                          "td",
                                          [
                                            _c("NumberStepperInput", {
                                              attrs: {
                                                min: "1",
                                                "input-class": "input-xs"
                                              },
                                              on: {
                                                input: function($event) {
                                                  return _vm.context.updateCallRoute(
                                                    callRoute
                                                  )
                                                }
                                              },
                                              model: {
                                                value:
                                                  callRoute.priority.weight,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    callRoute.priority,
                                                    "weight",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "callRoute.priority.weight"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        callRoute.callTarget
                                          ? _c("LinkedName", {
                                              attrs: {
                                                href: _vm.getHref(
                                                  "dashboard.target.edit",
                                                  {
                                                    name:
                                                      callRoute.callTarget.name,
                                                    targetId:
                                                      callRoute.callTarget.id
                                                  }
                                                ),
                                                title: callRoute.callTarget.name
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        callRoute.callTargetGroup
                                          ? _c("LinkedName", {
                                              attrs: {
                                                href: _vm.getHref(
                                                  "dashboard.targetgroup.edit",
                                                  {
                                                    name:
                                                      callRoute.callTargetGroup
                                                        .name,
                                                    targetGroupId:
                                                      callRoute.callTargetGroup
                                                        .id
                                                  }
                                                ),
                                                title:
                                                  callRoute.callTargetGroup.name
                                              }
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        callRoute.callPingTree
                                          ? _c("LinkedName", {
                                              attrs: {
                                                href: _vm.getHref(
                                                  "dashboard.ringtree.edit",
                                                  {
                                                    name:
                                                      callRoute.callPingTree
                                                        .name,
                                                    pingTreeId:
                                                      callRoute.callPingTree.id
                                                  }
                                                ),
                                                title:
                                                  callRoute.callPingTree.name
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.right.hover",
                                            value: _vm.getNumberDestinationRaw(
                                              callRoute
                                            ),
                                            expression:
                                              "getNumberDestinationRaw(callRoute)",
                                            modifiers: {
                                              right: true,
                                              hover: true
                                            }
                                          }
                                        ],
                                        staticClass:
                                          "max-width-80 overflow-ellipsis",
                                        attrs: { "aria-hidden": "true" }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.getNumberDestination(
                                                callRoute
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "max-width-100 overflow-ellipsis",
                                          attrs: {
                                            title: _vm.getConversionTypeName(
                                              callRoute
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.getConversionTypeName(
                                                  callRoute
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.getIsConversionTypeCallLength(
                                        callRoute
                                      )
                                        ? _c("div", { staticClass: "f-s-10" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.displayConversionTypeDetails(
                                                    callRoute
                                                  )
                                                ) +
                                                "\n              "
                                            )
                                          ])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "text-right" }, [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.getRevenue(callRoute)) +
                                          "\n            "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.context.routeContainer.id &&
                                    _vm.context.mode === "view"
                                      ? _c("td", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-list-function width-20",
                                              on: {
                                                click: function($event) {
                                                  return _vm.context.viewCallRoute(
                                                    callRoute.id
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "typcn typcn-edit",
                                                attrs: { "aria-hidden": "true" }
                                              })
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-center" },
                                      [
                                        _c("TargetStatus", {
                                          attrs: {
                                            entity:
                                              callRoute.callTarget ||
                                              callRoute.callTargetGroup ||
                                              callRoute.callPingTree
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isMobileView
                                      ? _c(
                                          "td",
                                          [
                                            _c("RoutingTargetActions", {
                                              attrs: {
                                                "call-route": callRoute
                                              },
                                              on: {
                                                "activate-route-actions":
                                                  _vm.context
                                                    .activateRouteActions,
                                                "edit-call-route":
                                                  _vm.context.editCallRoute,
                                                "delete-route":
                                                  _vm.context.deleteRoute
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isMobileView &&
                            _vm.context.activeActionRouteId == callRoute.id
                              ? _c(
                                  "tr",
                                  {
                                    key: `${callRoute.id}_actions`,
                                    staticClass:
                                      "mobile-actions ng-animate-disabled slide-right"
                                  },
                                  [
                                    _c(
                                      "td",
                                      { attrs: { colspan: "10" } },
                                      [
                                        _c("RoutingTargetActions", {
                                          attrs: { "call-route": callRoute },
                                          on: {
                                            "activate-route-actions":
                                              _vm.context.activateRouteActions,
                                            "edit-call-route":
                                              _vm.context.editCallRoute,
                                            "delete-route":
                                              _vm.context.deleteRoute
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        })
                      ],
                      2
                    )
                  }
                }
              ])
            },
            [
              _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
                _c(
                  "tr",
                  [
                    _vm.isMobileView ? _c("th") : _vm._e(),
                    _vm._v(" "),
                    !_vm.context.isRPC
                      ? _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_SELECTED_PRIORITY",
                              expression:
                                "'CAMPAIGN_STEP_ROUTING_SELECTED_PRIORITY'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: {
                            "sort-key": "priority.priority",
                            "default-sort": "asc"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.context.isRPC
                      ? _c("v-th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CAMPAIGN_STEP_ROUTING_SELECTED_WEIGHT",
                              expression:
                                "'CAMPAIGN_STEP_ROUTING_SELECTED_WEIGHT'"
                            }
                          ],
                          staticClass: "column-sortable",
                          attrs: { "sort-key": "priority.weight" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-th", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "CAMPAIGN_STEP_ROUTING_SELECTED_NAME",
                          expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_NAME'"
                        }
                      ],
                      staticClass: "column-sortable width-20-percent",
                      attrs: {
                        "sort-key": item =>
                          item.callTarget.name ||
                          item.callTargetGroup.name ||
                          item.callPingTree.name
                      }
                    }),
                    _vm._v(" "),
                    _c("v-th", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "CAMPAIGN_STEP_ROUTING_SELECTED_NUMBER",
                          expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_NUMBER'"
                        }
                      ],
                      staticClass: "column-sortable",
                      attrs: { "sort-key": "number" }
                    }),
                    _vm._v(" "),
                    _c("v-th", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "CAMPAIGN_STEP_ROUTING_SELECTED_TYPE",
                          expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_TYPE'"
                        }
                      ],
                      staticClass: "column-sortable",
                      attrs: {
                        "sort-key": item =>
                          item.conversionSettings[0].conversionType
                      }
                    }),
                    _vm._v(" "),
                    _c("v-th", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "CAMPAIGN_STEP_ROUTING_SELECTED_REVENUE",
                          expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_REVENUE'"
                        }
                      ],
                      staticClass: "column-sortable text-right",
                      attrs: {
                        "sort-key": item =>
                          item.conversionSettings[0].conversionValue
                      }
                    }),
                    _vm._v(" "),
                    _vm.context.mode === "view"
                      ? _c("v-th", [_vm._v("\n             \n          ")])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("v-th", {
                      directives: [
                        {
                          name: "t",
                          rawName: "v-t",
                          value: "STATUS_TEXT",
                          expression: "'STATUS_TEXT'"
                        }
                      ],
                      staticClass: "text-center column-sortable",
                      attrs: {
                        "sort-key": item =>
                          item.callTarget.enabled ||
                          item.callTargetGroup.enabled
                      }
                    }),
                    _vm._v(" "),
                    !_vm.isMobileView
                      ? _c("th", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "ACTIONS_COLUMN_HEADER",
                              expression: "'ACTIONS_COLUMN_HEADER'"
                            }
                          ]
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pagination-min" }, [
            _c(
              "div",
              { staticClass: "text-center p-0" },
              [
                _c("smart-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "total-pages": _vm.totalPages,
                    "max-page-links": 5
                  },
                  on: {
                    "update:currentPage": function($event) {
                      _vm.currentPage = $event
                    },
                    "update:current-page": function($event) {
                      _vm.currentPage = $event
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      !_vm.displayRoutes.length
        ? _c("div", { staticClass: "row" }, [
            _c("div", {
              directives: [
                {
                  name: "t",
                  rawName: "v-t",
                  value: "CAMPAIGN_STEP_ROUTING_SELECTED_DEFAULT",
                  expression: "'CAMPAIGN_STEP_ROUTING_SELECTED_DEFAULT'"
                }
              ],
              staticClass: "col-xs-12"
            })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }